import { Level, LevelName } from './level';
import { ThemeName } from '../themes/theme';
import { PassengerIcon } from '../Passenger';
import { PassengerSprite } from '../Passenger';
import { ObstacleName } from '../entities/obstacle/Obstacle';

export const level9: Level = {
  id: LevelName.Level9,
  theme: ThemeName.ParkSnow,
  laneItemDetails: {
    minLanesAtOnce: 1,
    maxLanesAtOnce: 2,
    antiRepeatSpawnDistance: 250,
    minSpawnAheadDistance: 1000,
    maxSpawnAheadDistance: 2000,
    defaultMaxSpawned: 1,
    defaultTimeBetweenSpawns: 6000,
    allowedObstacles: [ObstacleName.ObstacleBoxes, ObstacleName.ObstacleOilSlick, ObstacleName.ObstacleBananaSkin, ObstacleName.ObstacleWetConcrete, ObstacleName.ObstacleIcePatch, ObstacleName.ObstacleSnowDrift, ObstacleName.ObstacleLeafPile],
    obstacleConfiguration: {
      [ObstacleName.ObstacleBananaSkin]: { maxSpawned: 1, timeBetweenSpawns: 3000 }
    },
    boostConfiguration: { maxSpawned:2, timeBetweenSpawns: 2500 }
  },
  trafficDetails: {
    maxVehicles: 0,
    minTimeBetweenSpawns: 1000,
    maxTimeBetweenSpawns: 5000,
    minSpawnAheadDistance: 500,
    maxSpawnAheadDistance: 1000,
    maxLanesAtOnce: 2,
    minTimeBetweenSpeedChanges: 4000,
    maxTimeBetweenSpeedChanges: 7000
  },
  taxiDetails: {
    npcTaxis: 3,
    taxis: [
      {
        startLane: 1,
        startIndentX: 0
      },
      {
        startLane: 2,
        startIndentX: 0
      },
      {
        startLane: 3,
        startIndentX: 0
      }
    ]
  },
  passengerDetails: {
    defaultPassengerPickupBonus: 150,
    defaultPassengerDropOffBonus: 150,
    defaultPassengerDistanceRate: 2 / 100,
    passengers: [
      {
        sprite: PassengerSprite.Nine,
        icon: PassengerIcon.Nine,
        pickupDistance: 4000,
        travelDistance: 10000,
        passengerPickupBonus: 15,
        passengerDropOffBonus: 50,
        passengerDistanceRate: 5 / 1000
      },
      {
        sprite: PassengerSprite.Five,
        icon: PassengerIcon.Five,
        pickupDistance: 16000,
        travelDistance: 10000,
        passengerPickupBonus: 15,
        passengerDropOffBonus: 50,
        passengerDistanceRate: 5 / 1000
      },
      {
        sprite: PassengerSprite.Three,
        icon: PassengerIcon.Three,
        pickupDistance: 28000,
        travelDistance: 10000,
        passengerPickupBonus: 15,
        passengerDropOffBonus: 50,
        passengerDistanceRate: 5 / 1000
      },
      {
        sprite: PassengerSprite.Eleven,
        icon: PassengerIcon.Eleven,
        pickupDistance: 40000,
        travelDistance: 10000,
        passengerPickupBonus: 15,
        passengerDropOffBonus: 50,
        passengerDistanceRate: 5 / 1000
      },
      {
        sprite: PassengerSprite.Twelve,
        icon: PassengerIcon.Twelve,
        pickupDistance: 52000,
        travelDistance: 10000,
        passengerPickupBonus: 15,
        passengerDropOffBonus: 50,
        passengerDistanceRate: 5 / 1000
      },
      {
        sprite: PassengerSprite.Eighteen,
        icon: PassengerIcon.Eighteen,
        pickupDistance: 64000,
        travelDistance: 10000,
        passengerPickupBonus: 15,
        passengerDropOffBonus: 50,
        passengerDistanceRate: 5 / 1000
      }
    ]
  }
};
